import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionContact, ElectionContext, Round } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-poll-creation-sending-mode',
  templateUrl: 'poll-creation-sending-mode.component.html',
  styleUrls: ['./poll-creation-sending-mode.component.less', '../../../shared/common.less'],
})

export class PollCreationSendingModeComponent implements OnInit {
  @Input() contact: ElectionContact;
  @Input() smsMode: boolean = true;
  @Output() smsModeChange = new EventEmitter<boolean>();
  needPap: boolean = undefined;

  constructor() {}

  // onRoundChange() {
  //   this.selectedRoundChange.emit(this.selectedRound);
  // }

  onPartialChange() {
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  trackByIndex(index: number): number {
    return index;
  }

  
  ngOnInit(): void {
  }
}
